import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProcessingNoDataTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import processingIcon from "../../../../../assets/design-revamp-company/category-icons/processing_no_data_icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const ProcessingNoDataContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="processing-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("PROCESSING_NO_DATA_TITLE")}
          subDescription={t("PROCESSING_NO_DATA_DESC")}
          isNormal={true}
          number={"15.1A"}
          icon={processingIcon}
        />
      </div>
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-processingnodata-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          {" "}
          <ProcessingNoDataTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProcessingNoDataContents;
